// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1kzmJ","signatureButtonsRight":"ModalSign_signatureButtonsRight__2eWdH"};